import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'components/Panel';
import PanelHeader from 'components/Panel/components/PanelHeader';
import PanelBody from 'components/Panel/components/PanelBody';
import StatCard from 'components/Statistics/StatCard';
import ReactECharts from 'echarts-for-react';
import SkeletonBarChart from 'components/Loading/skeletonBarChart';
import { formatNumber } from 'utils/functions';

function SummaryAdminPerformance({
  literals = {},
  performance = null,
}) {
  const performanceChart = {
    series: [{
      name: literals.values,
      type: 'line',
      symbol: 'none',
      data: performance?.valuesPerDay?.map(op => op.value) || [],
    }],

    tooltip: {
      trigger: 'axis', valueFormatter: v => formatNumber(v),
    },
    legend: {
      data: [literals.values],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: performance?.valuesPerDay?.map(op => op.date.substr(5, 6)) || [],
      axisLabel: { rotate: 45 },
    },
    yAxis: {
      type: 'value',
    },
  };

  return (
    <div className='row mb-sp'>
      <div className='col-12 col-md-8'>
        <Panel className='m-0'>
          <PanelHeader title={literals.performance} subtitle={literals.lastMonthActivity} />
          <PanelBody>
            {
              !performance ? (
                <div className='d-flex align-items-center justify-content-center'>
                  <SkeletonBarChart height='200px' />
                </div>
              ) : (
                <ReactECharts option={performanceChart} style={{ height: 222 }} />
              )
            }
          </PanelBody>
        </Panel>
      </div>
      <div className='col-12 col-md-4'>
        <div className='d-flex flex-column justify-content-end h-100' style={{ gap: '21px' }}>
          <StatCard
            title={literals.createdKpis}
            value={performance?.custom}
            loading={!performance}
          />
          <StatCard
            title={literals.usedKpis}
            value={performance?.relations}
            loading={!performance}
          />
        </div>
      </div>
    </div>
  );
}

SummaryAdminPerformance.propTypes = {
  literals: PropTypes.object.isRequired,
  performance: PropTypes.object,
};

export default SummaryAdminPerformance;
